/**
 * Home page: hide desktop nav only at the very top of the page (scroll offset ~0).
 * Any scroll down reveals the menu; scrolling back to the top hides it again.
 * `data-home-nav` stays in sync with sticky/transparent header CSS in header.liquid.
 */
(function initHomeNavReveal() {
  const header = document.querySelector('#header-component');
  if (!header) return;
  if (header.dataset.homeNav === undefined) return;

  let raf = null;

  /** Treat subpixel / restore quirks as "still at top" */
  const isAtPageTop = () => window.scrollY <= 1;

  const update = () => {
    header.dataset.homeNav = isAtPageTop() ? 'pending' : 'revealed';
  };

  const onScroll = () => {
    if (raf != null) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      update();
    });
  };

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', update);

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', () => {
      header.dataset.homeNav = 'pending';
      update();
    });
  }
})();
